import PrivacyStatement from './PrivacyStatement';

export default PrivacyStatement;
